import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const errorsGenericNotFoundRoute: InvariantJiraRoute = {
	name: 'errors-generic-not-found',
	path: '/jira/:invalidPath',
};
